import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { DirectDataInputEntity } from "domain/entity/DirectDataInput/DirectDataInputEntity";
import { DirectDataInputSearchCriteria } from "domain/entity/DirectDataInput/DirectDataInputSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import { DirectDataInputRepository } from "./DirectDataInputRepo";

export const DirectDataInputRepoImpl = (): DirectDataInputRepository => {

    const getEntities = async (criteria: DirectDataInputSearchCriteria): Promise<DirectDataInputEntity[]> => {
        const url = '/v1/directDataInput';
        return await axiosPostData(chargeAxiosInstance, `${url}`, criteria).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }

    const unConfirmEntity = async (ids: number[]): Promise<ResponseEntity> => {
        const url = '/v1/directDataInputUnconfirm';
        return await axiosPostData(chargeAxiosInstance, `${url}`, ids);
    }

    const saveEntity = async (data: DirectDataInputEntity): Promise<ResponseEntity> => {
        const url = '/v1/directDataInputSave';
        return await axiosPostData(chargeAxiosInstance, `${url}`, data);
    }

    const confirmEntity = async (ids: number[]): Promise<ResponseEntity> => {
        const url = '/v1/directDataInputConfirm';
        return await axiosPostData(chargeAxiosInstance, `${url}`, ids);
    }

    const deleteEntity = async (ids: number[]): Promise<ResponseEntity> => {
        const url = '/v1/directDataInputDelete';
        return await axiosPostData(chargeAxiosInstance, `${url}`, ids);
    }

    return {
        getEntities: getEntities,
        confirmEntity: confirmEntity,
        unConfirmEntity: unConfirmEntity,
        saveEntity: saveEntity,
        deleteEntity: deleteEntity,
    }
}